"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EditorialExcellence() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const paragraphs = [{
    text: "C"
  }, {
    text: "on Niki Barrios, cada sesión comienza con intención. Estudio el lienzo natural de tus características antes de tocar un pincel. Curé mis paletas, refino mis técnicas y obtengo solo los productos profesionales de más alta calidad. El artistry, para mí, no es solo transformación — es una colaboración de belleza."
  }];
  return <section data-section-id="3020" id="editorial-excellence" className="bg-background text-foreground py-32 md:py-[200px] px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {}
          <div ref={imageRef} className="relative">
            <div className="relative">
              {}
              <div className="absolute inset-0 translate-x-3 translate-y-3 border pointer-events-none transition-opacity duration-1000" style={{
              borderColor: "var(--primary)",
              opacity: imageVisible ? 0.6 : 0,
              transitionDelay: "800ms"
            }} aria-hidden="true" />

              {}
              <div className="relative overflow-hidden" style={{
              aspectRatio: "4 / 5",
              clipPath: imageVisible ? "inset(0% 0% 0% 0%)" : "inset(100% 0% 0% 0%)",
              transition: "clip-path 1400ms cubic-bezier(0.22, 1, 0.36, 1)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png-wvc-sizes" alt="Signature editorial makeup look by Niki B. Makeup" loading="lazy" decoding="async" className="w-full h-full object-cover" style={{
                filter: "sepia(0.15) contrast(1.05)"
              }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-09-151903.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/ae9261ca-f07a-4353-a8a2-064606bdf890-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-09-151903.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-09-151903.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-09-151903.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-09-151903.webp" src="https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-09-151903.png" />
              </div>
            </div>

            {}
            <div className="mt-6 flex items-center gap-3 transition-all duration-1000" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateY(0)" : "translateY(12px)",
            transitionDelay: "1200ms"
          }}>
              <span className="h-px w-8" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />
              <span className="font-mono text-[11px] tracking-[0.2em] uppercase" style={{
              color: "var(--muted-foreground)"
            }}><br /></span>
            </div>
          </div>

          {}
          <div ref={textRef} className="lg:pl-12 xl:pl-20">
            {}
            <div className="transition-all duration-700 ease-out" style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateY(0)" : "translateY(20px)"
          }}>
              <p className="font-mono text-[11px] tracking-[0.25em] uppercase mb-10" style={{
              color: "var(--primary)"
            }}>
                — Capítulo I · Filosofía
              </p>
            </div>

            {}
            <h2 className="font-default font-light leading-[1.05] text-4xl md:text-5xl lg:text-[56px] mb-12 transition-all duration-700 ease-out" style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: "80ms",
            color: "var(--foreground)"
          }}>
              Definiendo tu
              <br />
              <em className="italic font-light" style={{
              color: "var(--primary)"
            }}>
                elegancia natural.
              </em>
            </h2>

            {}
            <div className="h-px w-16 mb-10 transition-all duration-700 ease-out" style={{
            backgroundColor: "var(--primary)",
            opacity: textVisible ? 0.7 : 0,
            transform: textVisible ? "scaleX(1)" : "scaleX(0)",
            transformOrigin: "left",
            transitionDelay: "160ms"
          }} aria-hidden="true" />

            {}
            <div className="space-y-7">
              {paragraphs.map((para, i) => <p data-index={i} key={i} className="font-default text-[17px] leading-[1.8] transition-all duration-700 ease-out" style={{
              opacity: textVisible ? 1 : 0,
              transform: textVisible ? "translateY(0)" : "translateY(20px)",
              transitionDelay: `${240 + i * 80}ms`,
              color: "var(--foreground)"
            }}>
                  {i === 0 ? <>
                      <span className="float-left font-default italic font-light mr-3 mt-1 leading-[0.85]" style={{
                  fontSize: "72px",
                  color: "var(--primary)"
                }}>
                        C
                      </span>
                      {para.text.substring(1)}
                    </> : para.text}
                </p>)}
            </div>

            {}
            <div className="mt-14 lg:ml-16 lg:pl-8 border-l transition-all duration-700 ease-out" style={{
            borderColor: "var(--primary)",
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: "480ms"
          }}>
              <blockquote className="font-default italic text-2xl md:text-[24px] leading-[1.5] mb-4" style={{
              color: "var(--foreground)"
            }}>
                « La belleza es la armonía entre propósito y expresión. »
              </blockquote>
              <cite className="not-italic font-mono text-[11px] tracking-[0.2em] uppercase" style={{
              color: "var(--muted-foreground)"
            }}>
                Niki B. · Artista de Maquillaje Profesional
              </cite>
            </div>

            {}
            <div className="mt-16 transition-all duration-700 ease-out" style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: "560ms"
          }}>
              <Button asChild variant="ghost" className="group h-auto px-0 py-2 font-default text-base hover:bg-transparent hover:text-primary">
                <Link to="/AboutPage" className="inline-flex items-center gap-3">
                  <span className="font-mono text-[12px] tracking-[0.25em] uppercase border-b pb-1" style={{
                  borderColor: "var(--border)"
                }}>Lee Su Historia</span>
                  <ArrowRight className="size-4 transition-transform duration-500 group-hover:translate-x-2" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}